import { render, staticRenderFns } from "./batchingFinishPrice.vue?vue&type=template&id=c043e82a&scoped=true&"
import script from "./batchingFinishPrice.vue?vue&type=script&lang=js&"
export * from "./batchingFinishPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c043e82a",
  null
  
)

export default component.exports